import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { label: "Features", href: "#features" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Screenshots", href: "#screenshots" },
  { label: "Benefits", href: "#benefits" },
];

export const Logo = () => (
  <span className="flex items-center gap-2" data-testid="toto-logo">
    <span className="flex h-9 w-9 items-center justify-center overflow-hidden rounded-xl shadow-sm">
      <img src="/assets/logo-mark.png" alt="TOTO logo" className="h-full w-full object-cover" />
    </span>
    <span className="font-heading text-xl font-bold tracking-tight text-slate-900">TOTO</span>
  </span>
);

export const Header = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const goTo = (e, href) => {
    e.preventDefault();
    setOpen(false);
    if (window.location.pathname !== "/") {
      navigate("/" + href);
    } else {
      document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-white/40 bg-white/80 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link to="/" aria-label="TOTO home" data-testid="header-home-link">
          <Logo />
        </Link>
        <nav className="hidden items-center gap-8 md:flex" aria-label="Primary">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => goTo(e, l.href)}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}-link`}
              className="text-sm font-semibold text-slate-600 transition-colors hover:text-toto-blue focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-toto-blue focus-visible:ring-offset-2"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="hidden md:block">
          <a
            href="#get-toto"
            onClick={(e) => goTo(e, "#get-toto")}
            data-testid="header-get-toto-button"
            className="inline-flex items-center rounded-full bg-toto-blue px-5 py-2.5 text-sm font-semibold text-white shadow-[0_8px_20px_rgba(27,44,200,0.25)] transition-all hover:-translate-y-0.5 hover:bg-toto-blue-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-toto-blue focus-visible:ring-offset-2"
          >
            Get TOTO
          </a>
        </div>
        <button
          className="rounded-lg p-2 text-slate-700 hover:bg-slate-100 md:hidden"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <div className="border-t border-slate-100 bg-white px-4 pb-6 pt-2 md:hidden" data-testid="mobile-menu">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => goTo(e, l.href)}
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}-link`}
              className="block rounded-lg px-3 py-3 text-base font-semibold text-slate-700 hover:bg-slate-50"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#get-toto"
            onClick={(e) => goTo(e, "#get-toto")}
            data-testid="mobile-get-toto-button"
            className="mt-3 block rounded-full bg-toto-blue px-5 py-3 text-center text-sm font-semibold text-white"
          >
            Get TOTO
          </a>
        </div>
      )}
    </header>
  );
};
